.goal-row-icon-container {
    width: 18px;
    display: flex;
    justify-content: center;
}
